import React from 'react'
import MasterLayout from "../masterLayout/MasterLayout";
import NonInventoryItemListLayer from '../components/NonInventoryItemListLayer';


export const NonInventoryItemListPage = () => {
  return (
<>

      {/* MasterLayout */}
      <MasterLayout>
<NonInventoryItemListLayer  />
      </MasterLayout>
</>  )
}
